'use client';
import { TelegramProductShortResponseDto } from '@/generated';
import { useMemo } from 'react';
import { Carousel } from '../Carousel';
import { ProductBigPreview } from '../Product/productBigPreview';
import { useMediaQuery } from 'usehooks-ts';

type ProductCarouselProps = {
  similarProducts: TelegramProductShortResponseDto[];
};

export const ProductViewCarouselClient: React.FC<ProductCarouselProps> = ({ similarProducts }) => {
  const isTablet = useMediaQuery('(min-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const autoTablet = useMemo(() => {
    let val = '160px';

    if (isTablet) {
      val = '225px';
    }

    if (isDesktop) {
      val = '25%';
    }

    return val;
  }, [isDesktop, isTablet]);

  return (
    <Carousel
      options={{ dragFree: true, align: 'start', containScroll: 'trimSnaps' }}
      showDots={false}
      slideHeight='auto'
      slideSize={autoTablet}
      slideSpacing='12px'
      carouselPadding='0px'
      showTopButtons={true}
      buttonClassName='lg:block hidden'
    >
      {similarProducts.map((product) => (
        <div className='w-full' key={product.id}>
          <ProductBigPreview product={product as TelegramProductShortResponseDto} />
        </div>
      ))}
    </Carousel>
  );
};
